import { useParams } from "react-router-dom"

const useIsCorpView = () => {
  const values = {
    route: useParams().customerNumber,
  }

  const isCorpView = Boolean(values.route)

  return isCorpView
}

export default useIsCorpView
